import { z } from 'zod';
import { accessJustificationSchema } from './accessJustification.schema';
import { callerConfirmationSchema } from './callerConfirmation.schema';

export const accessPromptSchema = accessJustificationSchema.extend(callerConfirmationSchema.shape);

export type AccessPromptFormInput = z.input<typeof accessPromptSchema>;
export type AccessPromptFormValues = z.output<typeof accessPromptSchema>;
